'use client';

import { UTCDate } from '@date-fns/utc';
import { BettablePickemsHead } from '@/components/pickems/betting/BettablePickemsHead';
import { BettablePickemsList } from '@/components/pickems/betting/BettablePickemsList';
import { BettablePickemsStatus } from '@/components/pickems/betting/BettablePickemsStatus';
import { PickemsBettingSkeleton } from '@/components/pickems/betting/PickemsBettingSkeleton';
import { usePickems } from '@/components/pickems/betting/usePickems.hook';
import type { Tournament } from '@/types/tournament';
import { TournamentsBetsTabs } from './TournamentsBetsTabs';

export const TournamentPickemsBetting = ({
  tournament,
  date = new UTCDate(),
}: {
  tournament: Tournament;
  date?: UTCDate;
}) => {
  const {
    pickems,
    selectedPickems,
    isLoading,
    handleSelect,
    handleClearAll,
    totalPickems,
  } = usePickems({ tournamentId: tournament.id });

  const handleSubmitSuccess = () => {
    handleClearAll();
  };

  if (isLoading) {
    return <PickemsBettingSkeleton />;
  }

  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-[1fr_23rem] lg:gap-5">
        <div className="rounded-lg bg-dark-gray px-4 py-6">
          <BettablePickemsHead date={date} totalPickems={totalPickems} />
          <BettablePickemsStatus pickems={pickems} />
          <BettablePickemsList
            onSelect={handleSelect}
            pickems={pickems}
            selectedPickems={selectedPickems}
          />
        </div>

        <div className="flex flex-col gap-4 rounded-lg bg-card-bg px-5 py-8">
          <TournamentsBetsTabs
            game={tournament.game}
            onClearAll={handleClearAll}
            onRemove={(pickemId) => handleSelect(pickemId, '')}
            onSuccess={handleSubmitSuccess}
            selectedPickems={selectedPickems}
            totalPickems={totalPickems}
            tournament={tournament}
          />
        </div>
      </div>
    </div>
  );
};
